import {
  ApplicationConfig,
  APP_ID,
  ErrorHandler,
  importProvidersFrom,
} from "@angular/core";
import {
  provideRouter,
  PreloadAllModules,
  withPreloading,
  withComponentInputBinding,
} from "@angular/router";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { provideClientHydration } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideServiceWorker } from "@angular/service-worker";
import * as Sentry from "@sentry/angular";
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from "ngx-google-analytics";

import { environment } from "../environments/environment";

Sentry.init({
  dsn: "https://9d5daad7df1a41c7b4686d8c5260a439@o219666.ingest.us.sentry.io/1363890",
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/quentinpetel\.fr/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_ID, useValue: "serverApp" },
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(
      [],
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
    ),
    provideServiceWorker("ngsw-worker.js", {
      enabled: environment.production,
    }),
    ...(environment.production
      ? [
          {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({ showDialog: false }),
          },
          {
            provide: Sentry.TraceService,
            deps: [],
          },
        ]
      : []),
    importProvidersFrom([
      NgxGoogleAnalyticsModule.forRoot("G-8TXTCSP6FV"),
      NgxGoogleAnalyticsRouterModule,
    ]),
  ],
};
